<app-create-update-default (entityLoaded)="entityLoaded($event)"
                           [buildPayload]="buildPayload"
                           [formGroup]="formGroup"
                           [id]="id"
                           (entitySaved)="entitySaved($event)"
                           [inDialog]="true"
                           [dontGoBakOnSaveSuccess]="true"
                           [service]="service"
                           [hideSaveButton]="hideSaveButton"
                            #createUpdateDefaultComponent>
    <ng-template template-content>

        <app-view-by-attribute (entityLoaded)="saleInvoiceConfigurationLoaded($event)"
                               *ngIf="accountBusinessCode"
                               [findByAttributeService]="saleInvoiceConfigurationService"
                               [value]="accountBusinessCode">
            <app-view-by-id-default (entityLoaded)="saleLoaded($event)" *ngIf="saleId" [findByIdService]="saleService"
                                    [id]="saleId">
            </app-view-by-id-default>
            <div class="row">
                <div class="col-12">
                    <app-card-v2 title="Informations générales">
                        <div class="row">
                            <app-form-field label="Concerne" [size]="12" [sizeLg]="12" [sizeXl]="12">
                                <app-sale-summary-field *ngIf="sale" [entity]="sale"></app-sale-summary-field>
                            </app-form-field>
                            <app-form-field [required]="true" label="Date" [size]="12" [sizeLg]="4" [sizeXl]="4">
                                <app-date-picker [parentFormGroup]="formGroup"
                                                 parentFormControlName="date"></app-date-picker>
                            </app-form-field>
                            <app-form-field label="Livre des factures" [required]="true">
                                <app-select [parentFormGroup]="formGroup" parentFormControlName="bookId" [elements]="bookElements"></app-select>
                            </app-form-field>
                            <app-form-field label="Numéro">
                                <app-input-text parentFormControlName="number" [parentFormGroup]="formGroup"
                                                (changedEvent)="refreshDocumentLabel()"></app-input-text>
                            </app-form-field>
                            <app-form-field [required]="true" label="Statut">
                                <app-lov-value-select-filter
                                        [parentFormGroup]="formGroup"
                                        lovListName="SALE_INVOICE_STATUS"
                                        parentFormControlName="statusValue"></app-lov-value-select-filter>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12">
                    <app-card-v2 title="Mise en page">
                        <div class="row">
                            <app-form-field label="Intitulé" [required]="true">
                                <app-input-text [parentFormGroup]="formGroup" parentFormControlName="documentLabel"></app-input-text>
                            </app-form-field>
                        </div>
                        <app-sale-invoice-report-options-input-form [title]="undefined"
                                                                    [configuration]="configuration"
                                                                    [partner]="sale?.partner"
                                                                    [userId]="sale?.responsibleUser?.id"
                                                                    [officeId]="sale?.office?.id"
                                                                    [formGroup]="reportFormGroup"></app-sale-invoice-report-options-input-form>
                    </app-card-v2>
                </div>
            </div>

            <!-- <ng-container *ngIf="!id && disableManualDocument === false">
                <a (click)="addDocument()" *ngIf="!documentFormGroupAdded"
                   style="cursor: pointer; text-decoration: underline;">Ajouter
                    un document</a>
                <a (click)="removeDocument()" *ngIf="documentFormGroupAdded"
                   style="cursor: pointer; text-decoration: underline;">Ne pas ajouter de document</a>
            </ng-container>


            <app-card *ngIf="documentFormGroupAdded" title="Document">
                <p>Ajouter un document uniquement si la facture ne doit pas être générée par l'application</p>
                <app-document-create-form #documentCreateForm [parentFormGroup]="documentFormGroup"
                                          [removeCategoryInput]="true"
                                          [removeLabelInput]="true"></app-document-create-form>
            </app-card> -->
            <app-document-download style="display: none;"
                                   [entity]="entity?.summary?.document"
                                   [downloadOnRefresh]="true"></app-document-download>
        </app-view-by-attribute>
    </ng-template>
</app-create-update-default>
